export default __webpack_public_path__ + "static/media/hero.6db807f2.jpg";